import NoteContainer from "./NoteContainer";
import { useLanguage } from "../../lib/LanguageContext";
import { genericTranslate } from "../../lib/funcs";

function Disclaimer() {
  const { languageData } = useLanguage();
  return (
    <NoteContainer title={genericTranslate(languageData, "Disclaimer")}>
      <p>
        {genericTranslate(languageData, "This app has no guarantees. By using it, you agree to take full responsibility for any risks.")}
        {" "}
        {genericTranslate(languageData, "We don't promise the app is accurate or error-free, and aren't liable for any damages, injuries, or problems that may arise.")}
        {" "}
        {genericTranslate(languageData, "This includes issues with linked websites, security breaches, or content you encounter while using the app.")}
        {" "}
        {genericTranslate(languageData, "We also don't endorse any advertisements or third-party services you find within the app.")}
      </p>  
    </NoteContainer>
  );
}

export default Disclaimer;